<template>
  <v-dialog max-width="640px" v-model="dialog" transition="dialog-transition" open-on-focus data-testid="timerange__dialog">
    <template v-slot:activator="{ on }" >
      <v-text-field
        ref="element"
        dense
        outlined
        :label="label || 'Time Range'"
        clearable
        v-on="on"
        :error-messages="error"
        class=""
        :value="formattedRangevalue"
        @click:clear="content = ['',''];tempContent = ['',''];updateValue()"
        :hide-details="hidedetails"
        :disabled="disabled"
        data-testid="timerange__textfield"
      ></v-text-field>
    </template>
    <v-card elevation="0" flat tile data-testid="timerange__card">
      <v-card-text class="pa-0 pt-3" data-testid="timerange__card-text-main">
        <div class="display-ib pl-5" data-testid="timerange__start-container">
          <h2 class="text-left mb-2 pl-4" data-testid="timerange__start-label">Start:</h2>
          <v-time-picker elevation="0" v-model="tempContent[0]" color="primary" scrollable :max="tempContent[1]" data-testid="timerange__start-picker">
          </v-time-picker>
        </div>
        <div class="display-ib px-5" data-testid="timerange__end-container">
          <h2 class="text-left mb-2 pl-4" data-testid="timerange__end-label">End:</h2>
          <v-time-picker elevation="0" v-model="tempContent[1]" color="primary" scrollable :min="tempContent[0]" data-testid="timerange__end-picker">
          </v-time-picker>
        </div>
      </v-card-text>
      <v-card-text class="text-right pt-4" data-testid="timerange__card-text-actions">
        <v-btn text @click="dialog = false;tempContent = content;updateValue()" data-testid="timerange__close-btn"><span data-testid="timerange__close-label">close</span></v-btn>
        <v-btn elevation="0" color="primary" @click="content = tempContent; dialog = false;updateValue()" :disabled="tempContent[0] === '' || tempContent[1] === ''" data-testid="timerange__ok-btn"><span data-testid="timerange__ok-label">ok</span></v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    activated() {
      this.setValue();
      this.updateValue();
    },
    created() {
      this.setValue();
      this.updateValue();
    },
    data: () => ({
      dialog: false,
      content: ['',''],
      tempContent: ['','']
    }),
    props: {
      error: {
        type: [String, Array],
      },
      label: {
        type: String,
      },
      value: {
        type: Array
      },
      hidedetails: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
      // required: {
      //   type: Boolean,
      //   default: false
      // }
    },
    methods: {
      setValue: function(){
        this.content = ["", ""];
        if(this.value instanceof Array){
          if(this.value.length === 2){
            let v = this.$nova.formatTime(this.value);
            if(v.length === 2) this.content = this.value;
          }
        }
      },
      updateValue: function () {
        this.$emit('input', this.content);
        this.$emit('change', this.content);
      },
      setFocus: function(){
        this.$nextTick(() => {
          this.$refs.element.$el.querySelector('input').focus();
        })
      },
      setBlank: function(){
        this.content = ['',''];
        this.tempContent = ['',''];
      }
    },
    computed:{
      formattedRangevalue(){
        let v = this.$nova.formatTime(this.content);
        if(v.length === 2) return v.join(" - ");
        else {
          this.setBlank();
          return [];
        }
      }
    },
    watch: {
      value: function(){
        this.setValue();
      }
    }
  }
</script>